module.exports = __webpack_public_path__ + "img/6.150712f0.jpg";